import React, { Component } from "react";
import { connect } from "react-redux";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import AppLayout from "./AppLayout";
import AuthLayout from "./AuthLayout";
import IndependentServiceLayout from "./IndependentServiceLayout";
import { getProfileGeneral, refreshToken } from "actions";
import { withRouter } from "react-router-dom";

class App extends Component {
  constructor(props) {
    super(props);
    this.authTimer = null;
  }

  componentDidMount() {
    this.tokenCheck();

    toastr.options = {
      positionClass: "toast-top-full-width",
      hideDuration: 300,
      timeOut: 5000,
    };
    toastr.clear();
  }

  componentWillUnmount() {
    clearInterval(this.authTimer);
  }

  tokenCheck = () => {
    if (this.authTimer) {
      clearInterval(this.authTimer);
    }

    if (this.checkTokenExpiration()) {
      this.refreshTokenHandle();
    }

    this.authTimer = setInterval(() => {
      if (this.checkTokenExpiration()) {
        this.refreshTokenHandle();
      }
    }, 10000);
  };

  checkTokenExpiration = () => {
    if (!localStorage.getItem("expiration")) return false;

    const nowUTC = new Date();
    const expUTC = new Date(localStorage.getItem("expiration"));
    const diff = Math.floor((new Date(expUTC) - nowUTC) / (1000 * 60));

    // 100dk altina dusmus ise...
    return diff <= 100;
  };

  refreshTokenHandle = (e) => {
    this.props.refreshToken(
      localStorage.getItem("refreshToken"),
      () => {},
      () => {
        console.log("token refreshed");
      },
      (err) => {
        console.log(err);
        window.location.replace("/login");
      }
    );
  };

  render() {
    if (
      !localStorage.getItem("token") ||
      this.props.history.location.pathname.toLowerCase() === "/logout"
    )
      return <AuthLayout />;

    if (Object.keys(this.props.generalProfile).length === 0) {
      this.props.getProfileGeneral(
        () => {},
        () => {},
        (err) => {
          console.log(err);
        }
      );
      return null;
    }

    if (this.props.generalProfile.isIndependentService)
      return <IndependentServiceLayout />;

    return <AppLayout />;
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
    application: state.application,
  };
};

export default connect(mapStateToProps, {
  getProfileGeneral,
  refreshToken,
})(withRouter(App));
